import { arrayToggle } from 'common/ArrayUtilities';
import { QueryParams } from 'common/urls/QueryParams';
import React, { useCallback } from 'react';
import { useRouteMatch } from 'react-router';
import { Protein } from 'src/gqlReactTypings.generated.d';
import { useDishFirstExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';
import { getProteinCategoriesToDisplay } from '../BrowseBy/BrowseByTags';
import { BaseFilterModal } from './BaseFilterModal';
import { DietaryButton } from './DietaryButton';
import { ButtonContainer, Container } from './DietaryFilterModal/styles';
import { useTrackFilterChange } from './hooks/useTrackFilterChange';

interface ProteinFilterModalProps {
  header: string;
  isShowing: boolean;
  largeHeader: boolean;
  onHide: () => void;
}

export const ProteinFilterModal: React.FC<ProteinFilterModalProps> = ({ header, isShowing, largeHeader, onHide }) => {
  const match = useRouteMatch();
  const filters = useDishFirstExploreUrl({ match });
  const { trackFilterChange } = useTrackFilterChange({ filters });

  const { updateQueryParams, proteinFilters } = filters;

  const onClick = useCallback(
    (proteinTag: Protein) => {
      const updates = { [QueryParams.PROTEIN_FILTER]: arrayToggle(proteinFilters || [], proteinTag) };
      updateQueryParams(updates);
      trackFilterChange(updates);
    },
    [updateQueryParams, proteinFilters, trackFilterChange]
  );

  const proteins = getProteinCategoriesToDisplay();

  return (
    <BaseFilterModal filters={filters} header={header} isShowing={isShowing} largeHeader={largeHeader} onHide={onHide}>
      <Container>
        <ButtonContainer>
          {proteins.map((protein) => (
            <DietaryButton
              filterTag={protein.label}
              icon={protein.icon}
              key={protein.tag}
              selected={filters.proteinFilters.includes(protein.tag)}
              onClick={() => onClick(protein.tag)}
            />
          ))}
        </ButtonContainer>
      </Container>
    </BaseFilterModal>
  );
};
